var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backend__container not-found__container"},[_c('div',{staticClass:"error_image"},[_c('img',{attrs:{"src":require("@/assets/common/images/404-error.jpg")}})])])
}]

export { render, staticRenderFns }